window.mysteryUpsellsLoaded = true;

(function () {
  var MYSTERY_VARIANT_IDS = ['47293983785213', '47293983817981', '47293983883517'];

  function getSectionId() {
    var el = document.querySelector('cart-items-component[data-section-id]');
    return el ? el.dataset.sectionId : null;
  }

  function updateDrawerHTML(sections, sectionId) {
    if (!sections || !sections[sectionId]) return;
    var parser = new DOMParser();
    var doc = parser.parseFromString(sections[sectionId], 'text/html');
    var newInner = doc.querySelector('.cart-drawer__inner');
    var curInner = document.querySelector('.cart-drawer__inner');
    if (newInner && curInner) {
      curInner.innerHTML = newInner.innerHTML;
      setTimeout(initMysteryUpsells, 100);
    }
  }

  function removeMysteryIfAlone(sectionId) {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cartData) {
        var items = cartData.items || [];
        var hasRealProduct = items.some(function (i) {
          return !MYSTERY_VARIANT_IDS.includes(String(i.variant_id));
        });
        if (hasRealProduct || items.length === 0) return Promise.resolve(null);
        var updates = {};
        items.forEach(function (i) { updates[i.key] = 0; });
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates, sections: sectionId })
        }).then(function (r) { return r.json(); });
      });
  }

  // Verifica si hay al menos un producto real en el carrito
  function cartHasRealProduct() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cartData) {
        var items = cartData.items || [];
        return items.some(function (i) {
          return !MYSTERY_VARIANT_IDS.includes(String(i.variant_id));
        });
      });
  }

  // Detectar si estamos en el product page (no en el drawer)
  function isProductPage() {
    return !document.querySelector('.cart-drawer__inner') ||
           !document.querySelector('cart-drawer-component dialog[open]');
  }

  function initMysteryUpsells() {
    document.querySelectorAll('.mystery-upsell-item__toggle').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';

      btn.addEventListener('click', function () {
        var variantId = btn.dataset.variantId;
        var item = btn.closest('.mystery-upsell-item');
        var isAdded = item.classList.contains('mystery-upsell-item--added');
        var sectionId = getSectionId();

        // Si está en product page y quiere AGREGAR, verificar que haya producto real
        if (!isAdded && isProductPage()) {
          cartHasRealProduct().then(function(hasReal) {
            if (!hasReal) {
              // No hacer nada — toggle no responde
              return;
            }
            // Tiene producto real, proceder normalmente
            doAdd(btn, item, variantId, sectionId);
          });
          return;
        }

        if (isAdded) {
          item.classList.remove('mystery-upsell-item--added');
        } else {
          item.classList.add('mystery-upsell-item--added');
        }
        btn.disabled = true;

        if (isAdded) {
          doRemove(btn, item, variantId, sectionId);
        } else {
          doAdd(btn, item, variantId, sectionId);
        }
      });
    });
  }

  function doAdd(btn, item, variantId, sectionId) {
    item.classList.add('mystery-upsell-item--added');
    btn.disabled = true;

    var body = { id: variantId, quantity: 1 };
    if (sectionId) body.sections = sectionId;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        btn.disabled = false;
        if (data.sections) updateDrawerHTML(data.sections, sectionId);
      })
      .catch(function (e) {
        console.error(e);
        item.classList.remove('mystery-upsell-item--added');
        btn.disabled = false;
      });
  }

  function doRemove(btn, item, variantId, sectionId) {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cartData) {
        var found = cartData.items.find(function (i) {
          return String(i.variant_id) === String(variantId);
        });
        if (!found) { btn.disabled = false; return; }
        var body = { id: found.key, quantity: 0 };
        if (sectionId) body.sections = sectionId;
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            btn.disabled = false;
            if (data.sections) updateDrawerHTML(data.sections, sectionId);
          });
      })
      .catch(function (e) {
        console.error(e);
        item.classList.add('mystery-upsell-item--added');
        btn.disabled = false;
      });
  }

  function watchCartForSoloMystery() {
    document.addEventListener('cart:update', function () {
      var sectionId = getSectionId();
      removeMysteryIfAlone(sectionId).then(function (data) {
        if (data && data.sections) updateDrawerHTML(data.sections, sectionId);
      });
    });
  }

  function watchLineItemRemove() {
    document.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('.cart-items__remove');
      if (!removeBtn) return;
      setTimeout(function () {
        var sectionId = getSectionId();
        removeMysteryIfAlone(sectionId).then(function (data) {
          if (data && data.sections) updateDrawerHTML(data.sections, sectionId);
        });
      }, 800);
    });
  }

  function bindDrawerOpen() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || drawer.dataset.upsellBound) return;
    drawer.dataset.upsellBound = 'true';
    drawer.addEventListener('dialog:open', function () {
      setTimeout(initMysteryUpsells, 200);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMysteryUpsells();
    bindDrawerOpen();
    watchCartForSoloMystery();
    watchLineItemRemove();
  });

  if (document.readyState !== 'loading') {
    initMysteryUpsells();
    bindDrawerOpen();
    watchCartForSoloMystery();
    watchLineItemRemove();
  }
})();